module.exports = __webpack_public_path__ + "img/gray-online-mentoring.adb708b4.png";